class LocalStorageManager {
    saveLocalStoarge(key, value){
        localStorage.setItem(key, value)
    }

    getItemFromStorage(key){
        return localStorage.getItem(key);
    }
}

export default new LocalStorageManager();